import styled, { css } from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/system';

export const StyledChestProduct = styled.div`
  height: 33%;

  .hov-main-product_product-img {
    width: 72px;
    height: 72px;
    left: 50%;
    top: -10px;
    position: absolute;
    transform: translateX(-50%);

    img {
      width: 100%;
    }
  }

  .chest-stars-section {
    position: absolute;
    top: 28%;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    box-sizing: border-box;
    width: 94%;
    min-height: 32px;
    background: rgba(111, 72, 216, 0.8);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .stars-section-container {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 11px;
      }
    }
  }

  .hov-main-product_offer-section {
    box-sizing: border-box;
    width: 100%;
    min-height: 32px;
    background: rgba(49, 25, 116, 0.5);
    border-radius: 100px;
    position: relative;
  }
` as any;

export const StyledCoinsProduct = styled.div`
  box-sizing: border-box;
  width: 94%;
  min-height: 32px;
  background: #6f48d8;
  border-radius: 100px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 3px;
  padding-bottom: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .product-img {
    margin-left: 10px;
    img {
      width: 30px;
      top: calc(50% - 23px);
      display: flex;
      justify-content: center;
      position: relative;
    }
  }

  .secondary-product__container {
    display: flex;
    align-items: center;
  }

  .product-quantity {
    font-size: 13px;
    font-weight: 700;
  }

  .product-rarity {
    display: flex;

    .product-rarity-stars {
      margin-left: 3px;
      display: flex;
      align-items: center;

      img {
        height: 8px;
      }
    }
  }
` as any;

export const StyledTextContainer = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-family: var(--font-family);

  .product-img img {
    width: 54px;
    position: absolute;
    top: calc(50% - 23px);
  }

  .secondary-product__container {
    display: flex;
    align-items: center;
  }

  .product-quantity {
    font-size: 13px;
    font-weight: 700;
  }

  .product-rarity {
    display: flex;

    .product-rarity-stars {
      margin-left: 3px;
      display: flex;
      align-items: center;

      img {
        height: 8px;
      }
    }
  }
` as any;

export const StyledQuantity = styled(Box)<{
  title: string;
  fontSize: number;
}>`
  z-index: 1;

  .quantity_text {
    font-size: ${({ fontSize }) => fontSize}px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    background: linear-gradient(
        180deg,
        #f8f3ef 0%,
        #fbcc85 49.36%,
        #fbdf99 100%
      )
      text;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;

    &:after {
      background: none;
      content: '${({ title }) => title}';
      left: 0;
      top: 0;
      z-index: -1;
      position: absolute;
      text-shadow: 0px 4.34px 4.34px rgba(0, 0, 0, 0.3);
    }
  }

  @media (width <= ${breakpoints.mobileM}) {
    font-size: ${({ fontSize }) => fontSize - 2}px;
  }
` as any;

export const StyledChestQuantity = styled(Box)`
  color: var(--text-labels-timers, #e2d7ff);
  text-align: center;
  text-shadow: 0px 2.341px 2.341px rgba(0, 0, 0, 0.3);
  font-family: Krub;
  font-size: 11.705px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;

  @media (width <= ${breakpoints.mobileM}) {
    font-size: 10px;
  }
` as any;

export const StyledStrokeQuantity = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-family: var(--font-family);

  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: line-through 2px red;
  color: #ffec85;

  @media (min-width: ${breakpoints.mobileL}) {
    font-size: 11px;
  }
` as any;

export const StyledLoyaltyPoints = styled(Box)<{
  title: string;
  isStroke?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  img {
    width: 10%;
  }

  .quantity_text {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #e2d7ff;
    position: relative;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }
`;
